import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Button,
  useMediaQuery,
  Hidden,
} from "@mui/material";
import bg from "../images/bg.png";
import logoH from "../images/FinalLogo.png";
import { useStakingContract1 } from "../hooks";
import { HashLink } from "react-router-hash-link";
import { formatUnits } from "@ethersproject/units";
import TimerCountDown from "./Timer";
import WalletConnectModal from "../modal";
import LogoutModal from "../logoutModal";
import { useWeb3React } from "@web3-react/core";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  nav: {
    background:
      "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
    borderRadius: "40.5px",
    border: "1.6875px solid #EEBE62",
    fontSize: "18.56px",
    fontWeight: 400,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 10px 5px rgba(238, 190, 98, 0.12)",
    "&:hover": {
      boxShadow: "0 0 11px 4px #EEBE62",
    },
  },
});
function Home() {
  const classes = useStyles();

  const matches = useMediaQuery("(max-width:750px)");
  const matches1 = useMediaQuery("(max-width:770px)");
  const { account } = useWeb3React();
  const stakingContract1 = useStakingContract1();
  const [totalInvestment, settotalInvestment] = useState(0);
  const [totalWithdrawalBNB, settotalWithdrawalBNB] = useState(0);
  const [insuranceFunds, setinsuranceFunds] = useState(0);
  const [logout, setlogout] = useState(false);
  const [connect, setconnect] = useState(false);

  const init = async () => {
    try {
      const totalDeposit = await stakingContract1.methods
        .total_deposited()
        .call();
      const totalWithdrawal = await stakingContract1.methods
        .total_withdrawn()
        .call();
      const insuranceFunds = await stakingContract1.methods
        .insurance_funds()
        .call();
      settotalInvestment(formatUnits(totalDeposit));
      settotalWithdrawalBNB(formatUnits(totalWithdrawal));
      setinsuranceFunds(formatUnits(insuranceFunds));
    } catch (error) {}
  };
  useEffect(() => {
    const interval = setInterval(() => {
      init();
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return (
    <Box
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      pt={{ xs: 0, sm: 15 }}
      pb={10}
      zIndex="1"
      position="relative"
    >
      <WalletConnectModal walletOpen={connect} setWalletOpen={setconnect} />
      <LogoutModal openLogout={logout} setopenLogout={setlogout} />

      <Container maxWidth="lg">
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={12} md={6}>
            <Box mt={3}>
              <Box
                fontFamily="Roboto"
                fontSize={{ xs: "30px", sm: "65px" }}
                fontWeight={700}
                lineHeight={matches ? "35px" : "80.86px"}
                color="text.primary"
              >
                Stable & Profitable Yield Farming Dapp on
                <Box component="span" color="#eebe62">
                  {" "}
                  Binance Smart Chain
                </Box>
              </Box>
              <Box
                fontFamily="Roboto"
                fontSize={{ xs: "20px", sm: "26px" }}
                fontWeight={400}
                lineHeight="30.47px"
                color="text.secondary"
                mt={1}
              >
                From 10% to 20% Daily ROI 5 Levels of Referral Rewards
              </Box>
              <Box display="flex" flexDirection="column">
                <HashLink
                  smooth
                  to="/#deposit"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    sx={{
                      width: matches ? "170px" : "218px",
                      height: matches ? "50px" : "68px",
                      borderRadius: "40.5px",
                      background:
                        "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                      backdropFilter: "blur(16.875px)",
                      border: " 1.69px solid #EEBE62",
                      color: "#fff",
                      textTransform: "capitalize",
                      fontSize: matches ? "20px" : "26px",
                      fontWeight: 400,
                      marginTop: matches ? "16px" : "25px",
                    }}
                  >
                    Deposit
                  </Button>
                </HashLink>
                <Box mt={matches ? 1 : 2} display="flex" alignItems="center">
                  <a
                    style={{
                      cursor: "pointer",
                      width: matches ? "170px" : "218px",
                      height: matches ? "50px" : "68px",
                      textDecoration: "none",
                    }}
                    href="https://bscscan.com/address/0x98C8f021418D09D48d5021701B8e6886531967B9"
                    target="_blank"
                  >
                    <Button
                      sx={{
                        // padding: "0px 30px",
                        width: matches ? "170px" : "218px",
                        height: matches ? "50px" : "68px",
                        borderRadius: "37.54px",
                        border: "2px solid #EEBE62",
                        background:
                          "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                        textTransform: "capitalize",
                        color: "#FDFCFC",
                        fontSize: matches ? "20px" : "26px",
                        fontWeight: 400,
                        backdropFilter: "blur(15.6406px)",
                        position: "relative",
                        zIndex: 2,
                      }}
                    >
                      Smart Contract
                    </Button>
                  </a>
                </Box>
                <Box display="flex" alignItems="center">
                  <Box mt={matches ? 1 : 2} display="flex" alignItems="center">
                    <a
                      style={{
                        cursor: "pointer",
                        width: matches ? "170px" : "218px",
                        height: matches ? "50px" : "68px",
                        textDecoration: "none",
                      }}
                      href="audit.pdf"
                      target="_blank"
                    >
                      <Button
                        sx={{
                          // padding: "0px 30px",
                          width: matches ? "170px" : "218px",
                          height: matches ? "50px" : "68px",
                          borderRadius: "37.54px",
                          border: "2px solid #EEBE62",
                          background:
                            "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 98%)",
                          textTransform: "capitalize",
                          color: "#FDFCFC",
                          fontSize: matches ? "20px" : "26px",
                          fontWeight: 400,
                          backdropFilter: "blur(15.6406px)",
                          position: "relative",
                          zIndex: 2,
                        }}
                      >
                        Audit
                      </Button>
                    </a>
                  </Box>
                  <Box mb={matches ? -1 : -3} ml={2}>
                    <img width={matches ? "50px" : "80px"} src={logoH} alt="" />
                  </Box>
                  <Box
                    mb={matches ? -1 : -2}
                    lineHeight={1}
                    ml={matches ? 1 : 2}
                    color="#EFB80B"
                    fontSize={matches ? "20px" : "40px"}
                    fontWeight="600"
                  >
                    HAZE
                    <br /> CRYPTO
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
            }}
          >
            <Box
              display="flex"
              mt={matches ? 3 : 2}
              flexDirection="column"
              width="100%"
            >
              <Box
                width={{ xs: "300px", sm: "270px" }}
                height="150px"
                bgcolor="rgba(238, 190, 98, 0.12)"
                borderRadius="12px"
                border="2px solid #eebe62"
                display="flex"
                justifyContent="center"
                alignSelf="center"
                alignItems="center"
                flexDirection="column"
                position="relative"
                bottom={matches ? "0px" : "30px"}
                sx={{ zIndex: 2, backdropFilter: "blur(20px)" }}
              >
                <Box
                  fontSize={{ xs: "20px", sm: "24px" }}
                  color="text.primary"
                  fontWeight={400}
                >
                  Total BNB Invested
                </Box>
                <Box
                  fontSize={{ xs: "40px", sm: "50px" }}
                  color="text.primary"
                  fontWeight={700}
                >
                  {parseFloat(totalInvestment).toFixed(2)}
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexDirection={matches ? "column" : "row"}
                width="100%"
              >
                {" "}
                <Box
                  width={{ xs: "300px", sm: "270px" }}
                  height="150px"
                  bgcolor="rgba(238, 190, 98, 0.12)"
                  borderRadius="12px"
                  border="2px solid #eebe62"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  sx={{ zIndex: 2, backdropFilter: "blur(20px)" }}
                  // position="relative"
                  // left={matches ? "0px" : "-60px"}
                  mt={matches ? 2 : 0}
                >
                  <Box
                    fontSize={{ xs: "20px", sm: "24px" }}
                    color="text.primary"
                    fontWeight={400}
                  >
                    Total BNB Reward
                  </Box>
                  <Box
                    fontSize={{ xs: "40px", sm: "50px" }}
                    color="text.primary"
                    fontWeight={700}
                  >
                    {parseFloat(totalWithdrawalBNB).toFixed(2)}
                  </Box>
                </Box>
                <Box
                  width={{ xs: "300px", sm: "270px" }}
                  height="150px"
                  bgcolor="rgba(238, 190, 98, 0.12)"
                  borderRadius="12px"
                  border="2px solid #eebe62"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  sx={{ zIndex: 2, backdropFilter: "blur(20px)" }}
                  mt={matches ? 2 : 0}
                >
                  <Box
                    fontSize={{ xs: "20px", sm: "24px" }}
                    color="text.primary"
                    fontWeight={400}
                  >
                    Insurance Funds
                  </Box>
                  <Box
                    fontSize={{ xs: "40px", sm: "50px" }}
                    color="text.primary"
                    fontWeight={700}
                  >
                    {parseFloat(insuranceFunds).toFixed(2)}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Home;
